exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "orders-feature {\n  max-width: 100%;\n  width: 74rem;\n  margin-left: auto;\n  margin-right: auto; }\n  @media screen and (max-width: 74rem) {\n    orders-feature {\n      padding: 0 1rem; } }\n\norders-feature {\n  position: relative;\n  min-height: 8rem;\n  display: block; }\n  orders-feature table {\n    width: 100%; }\n    orders-feature table th.button {\n      width: 10%; }\n  orders-feature .subtable th.articleNumber {\n    width: 12%; }\n", ""]);

// exports
